import $ from 'jquery';
import Chartist from 'chartist';

export const pco = () => {
  const $stats = $('#stats .ct-chart');

  // Rendering charts
  const executed = Number($stats.attr('data-executed') || '0');
  const todo = Number($stats.attr('data-todo') || '0');

  const labels = [];
  const series = [];

  if (executed > 0) {
    labels.push('réalisées');
    series.push({
      value: executed,
      className: 'green',
    });
  }

  if (todo > 0) {
    labels.push('à faire');
    series.push({
      value: todo,
      className: 'orange',
    });
  }

  if (executed > 0 || todo > 0) {
    const data = {
      labels,
      series,
    };

    const options = {
      height: 170,
      width: 242,
      labelInterpolationFnc: (value, index) => {
        return data.series[index].value + ' ' + value;
      },
    };

    return new Chartist.Pie('.ct-chart.ct-pie1', data, options);
  }
};



// WEBPACK FOOTER //
// ./src/modules/dashboard/index.js